import { computed, inject } from '@angular/core';
import { signalStore, withComputed, withMethods } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { withCallStatus } from '@ngrx-traits/signals';
import { withEntitiesLoadingCall } from '@ngrx-traits/signals';

import { ValuationTaxService } from '../data/valuation-tax.service';
import { ValuationTax } from '../models/valuation-tax.model';

const valuationTaxEntity = {
  entity: {} as ValuationTax,
  collection: 'valuationTaxOptions' as const,
  selectId: (entity: ValuationTax) => entity.id,
};

export const ValuationTaxStore = signalStore(
  withEntities(valuationTaxEntity),

  withCallStatus({ collection: 'valuationTaxOptions', initialValue: 'init' }),

  withEntitiesLoadingCall({
    collection: 'valuationTaxOptions',
    fetchEntities: () => {
      return inject(ValuationTaxService).getValuationTaxOptions();
    },
  }),

  withComputed((state) => ({
    valuationTaxOptionsCount: computed(() => {
      return state.valuationTaxOptionsEntities().length;
    }),

    getOptionByValue: computed(() => {
      const optionsMap = state.valuationTaxOptionsEntityMap();
      return (value: string) => {
        return (
          Object.values(optionsMap).find((option) => option.value === value) ||
          null
        );
      };
    }),

    optionsForDropdown: computed(() => {
      return state.valuationTaxOptionsEntities().map((option) => ({
        label: option.label,
        value: option.value,
      }));
    }),
  })),

  withMethods((state) => ({
    loadValuationTaxOptions: () => {
      if (
        !state.isValuationTaxOptionsEntitiesLoaded() &&
        !state.isValuationTaxOptionsEntitiesLoading()
      ) {
        state.setValuationTaxOptionsEntitiesLoading();
      }
    },

    findOptionByValue: (value: string) => {
      return (
        state
          .valuationTaxOptionsEntities()
          .find((option) => option.value === value) || null
      );
    },
  }))
);
